import React from 'react';
import { Categories, Category } from 'module/Model/Categories';
import { CategoryLink } from './CategoryLink';
import { ColumnsUtils, createPureComponent, PathUtils } from 'module/Common';
import { createLocalizedContent, LocalizedRenderer, RichText, WishHandler } from 'module/View/Common';
import { DescWrapper, Title, Wrapper } from './PublicationDescription.s';
import { Localized } from 'module/Model/Localized';
import { Wish } from 'module/Model/Wish';
import Scrollbars from 'react-custom-scrollbars';

const CategoriesHandler = WishHandler.create<Array<Category>>();

type Props = {
  title: Localized.Shape<string>;
  description: Localized.Shape<string>;
  cols: ColumnsUtils.ColumnsResult;
  lang: PathUtils.Lang;
  categoriesWish: false | Wish<Array<Category>>;
  innerRef?: (elem: HTMLElement | null) => void;
  inline?: boolean;
};

const DescriptionLocal = createLocalizedContent<string>();

export const PublicationDescription = createPureComponent<Props>(
  'PublicationDescription',
  ({ title, description, cols, categoriesWish, innerRef, inline = false, lang }) => {
    const descriptionWidth: number = cols.size(1);

    const scrollContent = (
      <DescWrapper width={cols.size(1)} inline={inline}>
        <Title dangerouslySetInnerHTML={{ __html: Localized.get(title, lang) }} />
        {categoriesWish && (
          <CategoriesHandler
            wish={categoriesWish}
            handlePending={() => <LocalizedRenderer renderFr={() => 'Chargement'} renderEn={() => 'Loading'} />}
            handleResolved={categories => {
              const basicCats = Categories.filterBasics(categories);
              const clientCats = Categories.filterClients(categories);
              return (
                <>
                  <CategoryLink categories={basicCats} />
                  <CategoryLink
                    categories={clientCats}
                    client={true}
                    prefixSingle={Localized.create('Client / ', 'Client / ')}
                    prefixMutiple={Localized.create('Clients / ', 'Clients / ')}
                  />
                </>
              );
            }}
          />
        )}
        <DescriptionLocal content={description}>{content => <RichText content={content} />}</DescriptionLocal>
      </DescWrapper>
    );

    return (
      <Wrapper descriptionWidth={descriptionWidth} innerRef={innerRef} inline={inline}>
        {inline ? (
          scrollContent
        ) : (
          <Scrollbars autoHide={true} style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }}>
            {scrollContent}
          </Scrollbars>
        )}
      </Wrapper>
    );
  }
);



// WEBPACK FOOTER //
// ./src/module/View/Publication/PublicationDescription/PublicationDescription.tsx